import clsx from 'clsx';
import React, { forwardRef } from 'react';
import { Button } from '../Button';
import { Badge } from '../Badge';
export const NavbarButton = forwardRef((props, ref) => {
    const { variant, hasNotification, elementType = 'button', children, ...rest } = props;
    return (React.createElement(Button, { ...rest, elementType: elementType, ref: ref, className: clsx('mollie-ui-navbar-button', {
            [`mollie-ui-navbar-button--${variant}`]: variant,
        }), UNSAFE_contentClassName: "mollie-ui-navbar-button-content" }, hasNotification ? (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "mollie-ui-navbar-button-notification-mask" }, children),
        React.createElement(Badge, { variant: hasNotification === 'attentive' ? 'negative' : 'informative', className: "mollie-ui-navbar-button-badge" }))) : (children)));
});
NavbarButton.displayName = 'Navbar.Button';
//# sourceMappingURL=NavbarButton.js.map